import React from "react";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import { HoverCard } from "./ResultsPrimitives.jsx";
import DispatchHeaderMenuSwitch from "./resultsPageChrome/DispatchHeaderMenuSwitch.jsx";

function ProtectAfterReassignmentHoverCardContent() {
  return (
    <div className="grid gap-2">
      <p className="m-0">
        Protège les commandes déplacées contre une optimisation ultérieure.
      </p>
      <p className="m-0 text-[11px] text-floating-faint">
        S’applique aux prochaines réaffectations seulement; ne libère pas les protections existantes.
      </p>
    </div>
  );
}

export default function ProtectAfterReassignmentToggle({
  checked = true,
  disabled = false,
  onChange = null,
  isMenuOpen = true,
} = {}) {
  const switchId = React.useId();
  const labelId = `${switchId}-label`;
  const descriptionId = `${switchId}-description`;
  const isDisabled = disabled || typeof onChange !== "function";

  return (
    <HoverCard
      title="Protéger après réaffectation"
      content={<ProtectAfterReassignmentHoverCardContent />}
      placement="bottom-end"
      delay={140}
      maxWidth="min(420px, calc(100vw - 48px))"
      disabled={!isMenuOpen}
      referenceAsChild
      flat
    >
      <button
        type="button"
        role="menuitemcheckbox"
        aria-checked={checked}
        aria-describedby={descriptionId}
        aria-labelledby={labelId}
        className="dispatch-header-menu-action"
        disabled={isDisabled}
        onClick={() => onChange?.(!checked)}
        tabIndex={-1}
        data-keep-menu-open="true"
        data-protect-after-reassignment-toggle="true"
      >
        <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 shrink-0" />
        <span id={labelId} className="min-w-0 flex-1">
          Protéger après réaffectation
        </span>
        <DispatchHeaderMenuSwitch checked={checked} />
        <span id={descriptionId} className="sr-only">
          Protège les commandes déplacées contre une optimisation ultérieure. S’applique aux prochaines réaffectations seulement; ne libère pas les protections existantes.
        </span>
      </button>
    </HoverCard>
  );
}
